import React, { useState } from 'react';

// Tic Tac Toe Game Component
function TicTacToe() {
  const [board, setBoard] = useState(Array(9).fill(null)); // Array representing the board (9 squares)
  const [isXNext, setIsXNext] = useState(true); // Track whose turn it is (X or O)
  const [winner, setWinner] = useState(null); // Track the winner of the game

  // Calculate winner based on current board state
  const calculateWinner = (board) => {
    const lines = [
      [0, 1, 2], // Row 1
      [3, 4, 5], // Row 2
      [6, 7, 8], // Row 3
      [0, 3, 6], // Column 1
      [1, 4, 7], // Column 2
      [2, 5, 8], // Column 3
      [0, 4, 8], // Diagonal 1
      [2, 4, 6], // Diagonal 2
    ];

    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (board[a] && board[a] === board[b] && board[a] === board[c]) {
        return board[a]; // Return the winner (X or O)
      }
    }
    return null;
  };

  // Handle cell click (update board)
  const handleClick = (index) => {
    if (board[index] || winner) return; // Don't allow click if cell is filled or game is over

    const newBoard = board.slice(); // Copy the current board
    newBoard[index] = isXNext ? 'X' : 'O'; // Update the clicked cell with X or O
    setBoard(newBoard);
    setIsXNext(!isXNext); // Toggle turn between X and O
    setWinner(calculateWinner(newBoard)); // Check if there is a winner
  };

  // Reset the game
  const handleReset = () => {
    setBoard(Array(9).fill(null)); // Clear the board
    setIsXNext(true); // Start with X
    setWinner(null); // No winner
  };

  // Render the game board
  const renderSquare = (i) => (
    <button
      className="square"
      onClick={() => handleClick(i)}
      style={{
        width: '60px',
        height: '60px',
        fontSize: '24px',
        margin: '5px',
        backgroundColor: '#f0f0f0',
        border: '1px solid #ccc',
        cursor: 'pointer',
        display: 'inline-block',
        borderRadius: '5px',
        fontFamily: 'Dancing Script', // Cursive font
      }}
    >
      {board[i]}
    </button>
  );

  return (
    <div
      style={{
        minHeight: '100vh', // Make sure the background covers the entire height
        background: 'linear-gradient(135deg, #ff9a9e 0%, #fad0c4 100%)',
        fontFamily: 'Dancing Script', // Cursive font
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        paddingTop: '30px',
        textAlign: 'center',
      }}
    >
      <h1 style={{ fontSize: '40px' }}>Tic Tac Toe</h1>
      <div>
        <p style={{ fontSize: '20px', fontStyle: 'italic', marginBottom: '20px' }}>
          {winner ? `You won! I love you 💖` : `Next Player: ${isXNext ? 'X' : 'O'}`}
        </p>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 60px)', // Creates a 3-column grid
          gridGap: '5px', // Gap between the squares
        }}
      >
        {Array(9).fill(null).map((_, index) => renderSquare(index))}
      </div>
      <div style={{ marginTop: '20px' }}>
        <button
          onClick={handleReset}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#ff5e5b',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '5px',
            fontFamily: 'Dancing Script', // Cursive font
          }}
        >
          Reset Game
        </button>
      </div>
    </div>
  );
}

export default TicTacToe;
